module.exports = __webpack_public_path__ + "img/product-ketang-jm-03.5b251c65.png";